import { BrowserRouter } from 'react-router-dom';
import { AccountKeyProvider } from './context/AccountKeyContext';
import { FamilyKeysProvider } from './context/FamilyKeysContext';
import { SafeProvider } from './context/SafeContext';
import { FamilyCategoriesProvider } from './context/FamilyCategoriesContext';
import { RecoveryProvider } from './context/RecoveryContext';
import AppShell from './components/AppShell';
import AppRouter from './router';

export default function App() {
  return (
    <BrowserRouter>
      <AccountKeyProvider>
        <FamilyKeysProvider>
          <SafeProvider>
            <FamilyCategoriesProvider>
              <RecoveryProvider>
                <AppShell>
                  <AppRouter />
                </AppShell>
              </RecoveryProvider>
            </FamilyCategoriesProvider>
          </SafeProvider>
        </FamilyKeysProvider>
      </AccountKeyProvider>
    </BrowserRouter>
  );
}
